import { axiosInstance as request } from '@api/rest.service'

const api = '/publications'

/**
 * @description GET /publications/create
 * @returns {AxiosPromise<any>}
 */
export const GET_PUBLICATIONS_CREATE = () => request.get(`${api}/create`)

/**
 * @description GET /publications/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_PUBLICATION = id => request.get(`${api}/${id}`)

/**
 * @description DELETE /publications/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_PUBLICATION = id => request.delete(`${api}/${id}`)
